import { cdnTemplate } from 'cdnPreprocessor';

export default [
  '$interval',
  '$timeout',
  function loadingButton($interval, $timeout) {
    return {
      restrict: 'E',
      //replace: true,
      scope: {
        text: '@',
        type: '@',
        block: '@',
        buttonClass: '@',
        submitFormId: '@',
        state: '=',
        buttonDisabled: '=',
      },
      templateUrl: cdnTemplate('/loading-button.html'),
      link: (scope, el, attrs) => {
        let progressInterval, resetTimeout;

        scope.progress = 1;
        scope.strokeDasharray = 204.24;
        scope.strokeDashoffset = 204.24;
        scope.block = scope.block || true;
        scope.buttonClass = scope.buttonClass || 'btn-primary';

        scope.$watch('state', (state) => {
          switch (state) {
            case 'loading':
              simulateLoad();
              break;
            case 'success':
              resetState();
              break;
            case 'error':
              resetState();
              break;
          }
        })

        function simulateLoad() {
          scope.progress = 0;
          progressInterval = $interval(() => {
            scope.progress += Math.random() * .5;
            scope.strokeDashoffset = calculateStrokeOffset((1 - scope.progress), 0, 1);

            if (scope.progress >= 1) {
              $interval.cancel(progressInterval)
            }
          }, 300);
        }

        function calculateStrokeOffset(num, min, max) {
          return scope.strokeDasharray * Math.min(Math.max(num, min), max);
        }

        function resetState() {
          resetTimeout = $timeout(() => {
            scope.state = null;
            scope.strokeDashoffset = calculateStrokeOffset((1 - 0), 0, 1);
          }, 3000);
        }

        el.on('$destroy', () => {
          $interval.cancel(progressInterval);
          $timeout.cancel(resetTimeout);
        });
      }
    }
  }
]



// WEBPACK FOOTER //
// ./source/client/layout-components/loading-button/loading-button.dir.js